var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

var site = site || {};

site.template = site.template || {};

(function ($) {
  Drupal.behaviors.skuSelectShadesV1 = {
    attach: function (context) {
      var $templates = $('.sku-select-shades-v1', context);

      $templates.each(function (i, obj) {
        var $template = $(obj);

        MantleSelectBox.attach_sku_selectbox($template);
        MantleSelectBox.order_options_by_name($template);
      });
    }
  };
})(jQuery);
